import { render, staticRenderFns } from "./MateDeliveryInfo.vue?vue&type=template&id=df4d1004&scoped=true"
import script from "./MateDeliveryInfo.vue?vue&type=script&lang=js"
export * from "./MateDeliveryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4d1004",
  null
  
)

export default component.exports